<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...$$props}>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M16.5 3.293 5.744 14 .5 8.78l1.3-1.293 3.944 3.926L15.2 2z"
    clip-rule="evenodd"
  />
</svg>
